<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="4.454016694220371 41.971109664762025 500.59667826464045 434.82809223225945"
        preserveAspectRatio="none"
    >
        <g>
            <defs>
                <path
                    id="s-Path_3-d1224"
                    d="M14.97213709202481 466.29920004304887 L173.7641480667704 399.07479132224466 "
                ></path>
            </defs>
            <g style="mix-blend-mode: normal">
                <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#s-Path_3-d1224"
                    fill="none"
                    stroke-width="20.0"
                    stroke="currentColor"
                    stroke-linecap="round"
                ></use>
            </g>
        </g>
        <g>
            <defs>
                <path
                    id="s-Line_5-d1224"
                    d="M174.10748008270915 399.0747913222448 L333.5110333357585 464.9576305837893 "
                ></path>
            </defs>
            <g style="mix-blend-mode: normal">
                <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#s-Line_5-d1224"
                    fill="none"
                    stroke-width="20.0"
                    stroke="currentColor"
                    stroke-linecap="round"
                ></use>
            </g>
        </g>
        <g>
            <defs>
                <path
                    id="s-Line_1-d1224"
                    d="M173.03933603312188 57.632425581515065 L173.03933603312186 398.9145697148067 "
                ></path>
            </defs>
            <g style="mix-blend-mode: normal">
                <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#s-Line_1-d1224"
                    fill="none"
                    stroke-width="20.0"
                    stroke="currentColor"
                    stroke-linecap="butt"
                ></use>
            </g>
        </g>
        <g>
            <defs>
                <path
                    id="s-Line_4-d1224"
                    d="M172.5143242072305 56.12806981354471 L336.11797206741096 120.4358735974151 "
                ></path>
            </defs>
            <g style="mix-blend-mode: normal">
                <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#s-Line_4-d1224"
                    fill="none"
                    stroke-width="20.0"
                    stroke="currentColor"
                    stroke-linecap="round"
                ></use>
            </g>
        </g>
        <g>
            <defs>
                <path
                    id="s-Line_2-d1224"
                    d="M336.4653756199593 120.28919437999272 L336.46537561995933 467.2757888883857 "
                ></path>
            </defs>
            <g style="mix-blend-mode: normal">
                <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#s-Line_2-d1224"
                    fill="none"
                    stroke-width="20.0"
                    stroke="currentColor"
                    stroke-linecap="butt"
                ></use>
            </g>
        </g>
        <g>
            <defs>
                <path
                    id="s-Line-d1224"
                    d="M14.954016694220401 125.52119224110214 L14.954016694220401 466.20764483879867 "
                ></path>
            </defs>
            <g style="mix-blend-mode: normal">
                <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#s-Line-d1224"
                    fill="none"
                    stroke-width="20.0"
                    stroke="currentColor"
                    stroke-linecap="round"
                ></use>
            </g>
        </g>
        <g>
            <defs>
                <path
                    id="s-Path_1-d1224"
                    d="M15.479028520111768 125.60348923035446 L171.64873874413544 55.60305798765335 "
                ></path>
            </defs>
            <g style="mix-blend-mode: normal">
                <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#s-Path_1-d1224"
                    fill="none"
                    stroke-width="20.0"
                    stroke="currentColor"
                    stroke-linecap="round"
                ></use>
            </g>
        </g>
        <g>
            <defs>
                <path
                    id="s-Path_2-d1224"
                    d="M336.4653756199592 120.22052797680499 L493.99039632829437 52.47110743010949 "
                ></path>
            </defs>
            <g style="mix-blend-mode: normal">
                <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#s-Path_2-d1224"
                    fill="none"
                    stroke-width="20.0"
                    stroke="currentColor"
                    stroke-linecap="round"
                ></use>
            </g>
        </g>
        <g>
            <defs>
                <path
                    id="s-Line_3-d1224"
                    d="M494.55069495886084 52.99611925600087 L494.5506949588609 392.1075363760232 "
                ></path>
            </defs>
            <g style="mix-blend-mode: normal">
                <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#s-Line_3-d1224"
                    fill="none"
                    stroke-width="20.0"
                    stroke="currentColor"
                    stroke-linecap="round"
                ></use>
            </g>
        </g>
        <g>
            <defs>
                <path
                    id="s-Path_4-d1224"
                    d="M333.8584368883071 464.74228496317915 L494.2254833407268 392.26775798346125 "
                ></path>
            </defs>
            <g style="mix-blend-mode: normal">
                <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#s-Path_4-d1224"
                    fill="none"
                    stroke-width="20.0"
                    stroke="currentColor"
                    stroke-linecap="round"
                ></use>
            </g>
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-accounting-plan",
});
</script>
